export default "__VITE_ASSET__BnBjppd2__"